import React from "react";
import { Github, Linkedin, Mail, ArrowUp } from "lucide-react";

const Footer = ({ contact = {}, hero = {} }) => {
  const socials = contact.socials || hero.socials || {};
  const email = contact.email || hero.email;

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="relative border-t border-white/5 mt-10" data-testid="footer">
      <div className="max-w-6xl mx-auto px-5 md:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className="font-display text-white text-xl">
            {hero.name || "Portfolio"}
            <span className="text-cyan-400">.</span>
          </div>
          <p className="mt-2 text-xs text-slate-500">© {new Date().getFullYear()} — Designed & engineered with care.</p>
        </div>
        <div className="flex items-center gap-3">
          {socials.github && <a href={socials.github} target="_blank" rel="noreferrer" data-testid="footer-github" aria-label="GitHub" className="w-9 h-9 rounded-lg glass grid place-items-center text-slate-300 hover:text-white"><Github size={15} /></a>}
          {socials.linkedin && <a href={socials.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin" aria-label="LinkedIn" className="w-9 h-9 rounded-lg glass grid place-items-center text-slate-300 hover:text-white"><Linkedin size={15} /></a>}
          {email && <a href={`mailto:${email}`} data-testid="footer-email" aria-label="Email" className="w-9 h-9 rounded-lg glass grid place-items-center text-slate-300 hover:text-white"><Mail size={15} /></a>}
          <button onClick={scrollTop} data-testid="footer-scroll-top" aria-label="Back to top" className="ml-2 w-9 h-9 rounded-lg bg-gradient-to-br from-cyan-400 to-violet-500 grid place-items-center text-black hover:shadow-[0_0_30px_rgba(0,240,255,0.35)] transition-shadow">
            <ArrowUp size={15} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
